export default {
    id: null,
    name: null,
    priority: 0,
    public: false,
    active: true,
    project: null,
    _status: null
}
